<template>
  <NavComponent  />
  <section id="courses">
    <div class="colored_banner">
      <h1>Guides</h1>
    </div>
    <div class="container">
      <!-- inside describtion from home sections -->
      <div v-if="titleObject" class="row">
        <div class="col-md-3 col-lg-3 col-xs-12"></div>
        <div class="col-md-6 col-lg-6 col-xs-12 p-0">
          <div
            id="about_info"
            class="p-4 p-sm-0"
            v-html="titleObject.inside_description"
          ></div>
        </div>
        <div class="col-md-3 col-lg-3 col-xs-12"></div>
      </div>

      <div class="row">
        <div class="col-12 col-xs-12" id="courses_container">
          <div>
            <div class="row">
              <div class="col-md-12 col-lg-12 col-xs-12">
                <!-- Error message div -->
                <div v-if="guides_error" class="alert alert-danger mt-3">
                  {{ guides_error }}
                </div>
                <div
                  v-else
                  class="row gy-4 row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-5"
                >
                  <GuideCell
                    v-for="(obj, index) in loadedGuides.value"
                    :key="index"
                    :obj="obj"
                  />
                </div>
              </div>
            </div>
          </div>

          <Loader :isLoading="isLoading" />
        </div>
      </div>
    </div>
   
  </section>
  <div id="line"></div>
  <FooterComponent />
</template>
<script>
import { watch, watchEffect, ref } from "vue";
import GetHomeSections from "@/composables/GetHomeSections";
import GetGuides from "@/composables/GetGuides";
//component
import NavComponent from "@/views/components/Nav";
import FooterComponent from "@/views/components/Footer";
import GuideCell from "@/views/components/GuideCell";
export default {
  name: "GuidesView",
  components: {
    NavComponent,
    FooterComponent,
    GuideCell,
  },
  data() {
    return {
      loadedGuides: ref([]),
      loadedLanguages: [],
      guides_error: null,
      isLoading: false,
    };
  },
  mounted() {
    const { loadedHomeSections, home_error, loadHomeSections } =  GetHomeSections();
    loadHomeSections();
    this.fetchGuides();

    this.isLoading = true;

  },
  methods: {


    fetchGuides() {
      const { loadedGuides, guides_error, load_guides } = GetGuides();

      watch([loadedGuides, guides_error], () => {
        if (!this.isRefEmpty(loadedGuides)) {
          console.log("loaded guides:", loadedGuides.value);
          this.loadedGuides.value = loadedGuides.value;
          this.guides_error = null; // Clear any previous error
          this.isLoading = false; // Set isLoading to false
        }
        if (!this.isRefEmpty(guides_error)) {
          console.log("guides error:", guides_error.value);
          this.guides_error = guides_error.value;
          this.loadedGuides.value = []; // Reset loaded guides
          this.isLoading = false; // Set isLoading to false
        }
      });
      load_guides();
    },
  


  
  },
  computed: {
    // TODO change this to guides_section
    titleObject() {
      return this.$store.getters.getHomeSections.find(
        (title) => title.name === "guides_section"
      );
    },
  },
};
</script>
